import React from 'react';
import { Modal } from 'antd';

/**
 * SpecModal
 * Central place for modal motion defaults (dissolve/fade).
 *
 * Ant's ConfigProvider `modal` config does NOT include `transitionName` /
 * `maskTransitionName`, so a wrapper is the clean global way to avoid repeating
 * these props for every modal.
 */
import { ModalProps } from 'antd';

// specLight4 shadow
const SPEC_LIGHT_4_SHADOW = '0px 20px 25px rgba(0,0,0,0.1), 0px 10px 10px rgba(0,0,0,0.04)';

export default function SpecModal(props: ModalProps) {
  return (
    <Modal
      transitionName="ant-fade"
      maskTransitionName="ant-fade"
      styles={{
        mask: {
          background: 'rgba(17, 17, 17, 0.6)', // colorBgSpotlight - enables specLight shadows
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
        },
        ...props.styles,
      }}
      modalRender={(modal) => {
        if (React.isValidElement(modal)) {
          const el = modal as React.ReactElement<any>;
          const patched = React.cloneElement(el, {
            style: {
              ...el.props.style,
              boxShadow: SPEC_LIGHT_4_SHADOW,
              padding: '16px 12px',
            },
          });
          return patched;
        }
        return modal;
      }}
      {...props}
    />
  );
}

